var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.error)?_c('v-button',{attrs:{"label":"Google","ico":"ion-social-googleplus","icoPosition":"left","classe":"button-dark btn-dark btn-google btn-block mb-3"},on:{"click":_vm.login}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068eb45c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialButtons/GoogleLogin.vue
// module id = null
// module chunks = 